export default __webpack_public_path__ + "static/media/KX-TG6811GB_HSD_gallery_global_03.05d8a499.jpg";